import * as React from "react";
import {default as CustomHeader, ICustomHeaderInfo} from "../../utils/CustomHeader";

const GoalEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "goalName", display: "Goal"},
    {label: "metric", display: "Metric"},
    {label: "current", display: "Current"},
    {label: "target", display: "Target"}
];

interface LCGoalsViewProps {
    updatedGoals: any[]
}

export default class LCGoalsView extends React.Component<LCGoalsViewProps> {

    render () {
        const hasGoals = (this.props.updatedGoals || []).length > 0;
        return (
            <div className={"lc-goals-view-cont lc-goal-editor"}>
                {hasGoals && <CustomHeader headerInfos={GoalEditorHeaderInfos} rootCls={"lc-goal"}/>}
                {
                    hasGoals ? this.props.updatedGoals.map((goalItem: any) => {
                        return (
                            <div className="lc-goal-item-view">
                                <div className={`lc-goal-name`}>
                                    {goalItem.item.goalName}
                                </div>
                                <div className={`lc-goal-metric`}>
                                    {goalItem.item.metric}
                                </div>
                                <div className="lc-goal-current">
                                    {goalItem.item.current}
                                </div>
                                <div className="lc-goal-target">
                                    {goalItem.item.target}
                                </div>
                            </div>
                        )
                    }) : <div>No Goals present</div>
                }
            </div>
        )
    }
}